// Mock data for SmartLogis

export const products = [
  {
    id: 1,
    name: "Kit Débutant",
    price: 249.99,
    description: "Parfait pour commencer votre maison intelligente",
    image: "https://images.unsplash.com/photo-1730967844913-29eb5cae5f34",
    features: ["2 ampoules intelligentes", "1 prise connectée", "1 capteur de mouvement", "1 Hub (Cerveau intelligent)", "Installation professionnelle incluse"],
    category: "kit",
    compatible: "Compatible avec Alexa, Google Home et Apple Home"
  },
  {
    id: 2,
    name: "Kit Confort",
    price: 399.99,
    description: "Solution complète pour votre appartement",
    image: "https://images.pexels.com/photos/29091470/pexels-photo-29091470.jpeg",
    features: ["6 ampoules intelligentes", "2 prises connectées", "2 capteurs", "1 Hub (Cerveau intelligent)", "Installation professionnelle incluse"],
    category: "kit",
    popular: true,
    compatible: "Compatible avec Alexa, Google Home et Apple Home"
  },
  {
    id: 3,
    name: "Kit Premium",
    price: 599.99,
    description: "L'expérience domotique ultime",
    image: "https://images.unsplash.com/photo-1736410223296-4537159eefe4",
    features: ["8 ampoules intelligentes", "4 prises connectées", "3 capteurs", "1 Hub (Cerveau intelligent)", "Installation professionnelle incluse"],
    category: "kit",
    compatible: "Compatible avec Alexa, Google Home et Apple Home"
  },
  {
    id: 4,
    name: "Ampoule Intelligente",
    price: 29.99,
    description: "16 millions de couleurs, contrôle vocal",
    image: "https://images.unsplash.com/photo-1736410223296-4537159eefe4",
    features: ["Compatible Alexa/Google/Apple", "WiFi intégré", "Économie d'énergie"],
    category: "accessory"
  },
  {
    id: 5,
    name: "Prise Connectée",
    price: 24.99,
    description: "Contrôlez vos appareils à distance",
    image: "https://images.unsplash.com/photo-1730967844913-29eb5cae5f34",
    features: ["Programmation horaire", "Suivi consommation", "Contrôle à distance"],
    category: "accessory"
  },
  {
    id: 6,
    name: "Caméra de Sécurité Intelligente",
    price: 60.00,
    description: "Surveillez votre domicile en temps réel",
    image: "https://images.unsplash.com/photo-1736410223296-4537159eefe4",
    features: ["Vision nocturne HD", "Détection de mouvement", "Communication audio bidirectionnelle", "Notifications instantanées", "Enregistrement cloud"],
    category: "accessory"
  },
  {
    id: 7,
    name: "Serrure Intelligente (Smart Lock)",
    price: 199.99,
    description: "Sécurisez votre porte d'entrée",
    image: "https://images.pexels.com/photos/29091470/pexels-photo-29091470.jpeg",
    features: ["Déverrouillage par code/app", "Historique d'accès", "Installation sans perçage", "Accès invités temporaires"],
    category: "accessory"
  }
];

export const services = [
  {
    id: 1,
    name: "Installation Standard",
    price: 99.99,
    duration: "2-3 heures",
    description: "Installation complète de votre kit",
    features: [
      "Installation de tous les appareils",
      "Configuration du réseau",
      "Formation de base",
      "Support 30 jours"
    ]
  },
  {
    id: 2,
    name: "Installation Premium",
    price: 199.99,
    duration: "3-4 heures",
    description: "Service complet avec personnalisation",
    features: [
      "Tout du service standard",
      "Configuration avancée",
      "Scénarios personnalisés",
      "Formation complète",
      "Support 90 jours"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Configuration À Distance",
    price: 49.99,
    duration: "1 heure",
    description: "Assistance en ligne pour configuration",
    features: [
      "Support vidéo en direct",
      "Configuration logicielle",
      "Guide personnalisé",
      "Support 14 jours"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Tremblay",
    location: "Sainte-Marthe-sur-le-Lac",
    rating: 5,
    comment: "Excellent service! L'installation a été rapide et professionnelle. Mon appartement est maintenant totalement connecté.",
    date: "2024-11-15"
  },
  {
    id: 2,
    name: "Jean-Philippe Dubois",
    location: "Deux-Montagnes",
    rating: 5,
    comment: "Parfait pour les locataires. Je peux tout emporter quand je déménage. L'équipe SmartLogis est très compétente.",
    date: "2024-11-08"
  },
  {
    id: 3,
    name: "Sophie Lavoie",
    location: "Sainte-Marthe-sur-le-Lac",
    rating: 5,
    comment: "Le Kit Confort est génial! Les économies d'énergie sont réelles et l'application est très simple à utiliser.",
    date: "2024-10-28"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Puis-je emporter mon kit si je déménage?",
    answer: "Absolument! C'est l'avantage principal de nos kits. Tous nos produits sont portables et peuvent être facilement retirés et réinstallés dans votre nouveau logement."
  },
  {
    id: 2,
    question: "Ai-je besoin d'autorisation de mon propriétaire?",
    answer: "Non, nos installations ne nécessitent aucune modification permanente. Aucune autorisation n'est requise car tout peut être retiré sans trace."
  },
  {
    id: 3,
    question: "Quelle est la zone de service?",
    answer: "Nous desservons Montréal et ses environs (Laval, Longueuil, Rive-Nord, Rive-Sud). Contactez-nous pour confirmer votre adresse."
  },
  {
    id: 4,
    question: "Offrez-vous une garantie?",
    answer: "Oui, tous nos produits sont garantis 2 ans. Notre service d'installation inclut également un support technique gratuit."
  },
  {
    id: 5,
    question: "Puis-je installer moi-même?",
    answer: "Oui! Nos kits sont conçus pour être faciles à installer. Mais nous recommandons notre service d'installation pour une expérience optimale et une configuration personnalisée."
  }
];

export const timeSlots = [
  "09:00", "10:00", "11:00", "13:00", "14:00", "15:00", "16:00", "17:00"
];

export const serviceAreas = [
  "Montréal",
  "Laval",
  "Longueuil",
  "Rive-Nord",
  "Rive-Sud",
  "Ouest-de-l'Île"
];
